import VisitorLandingPageContainer from './VisitorLandingPage.container';

export * from './types';
export * from './VisitorLandingPage';

export default VisitorLandingPageContainer;